import { IonButton, IonCard, IonCardContent } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import InputForm from "../../components/common/input-form";
import WithNavigation from "../../hoc/with-navigation";
import useForm from "../../hooks/use-form";
import { SelectOption } from "../../interfaces";
import { useSettings } from "../../store/settings";

import "./styles.css";

const Settings: React.FC = () => {
	const history = useHistory();
	const { settings, updateSettings } = useSettings();
	const { t } = useTranslation();

	const { handleUpdates, handleSubmit, formState } = useForm(undefined, {
		initialState: settings,
	});

	const handleSubmitSettings = (formState) => {
		updateSettings(formState);
		history.replace("/home");
	};

	const langs: SelectOption[] = [
		{ key: "es", label: "Español" },
		{ key: "en", label: "English" },
		{ key: "fr", label: "Français" },
		{ key: "it", label: "Italiano" },
		{ key: "pt", label: "Português" },
	];

	const measureUnits: SelectOption[] = [
		{ key: "ft", label: "Feet" },
		{ key: "m", label: "Meters" },
		{ key: "yd", label: "Yards" },
	];

	return (
		<WithNavigation checkUser={true} preventGoBack={false} text="TVM">
			<IonCard>
				<IonCardContent>
					<InputForm
						label={t("settings.language.label")}
						id="lang-input"
						type="select"
						value={formState.state.lang}
						options={langs}
						onValueChange={handleUpdates("lang")}
					></InputForm>
					<InputForm
						label={t("settings.company.label")}
						id="company-input"
						value={formState.state.company}
						onValueChange={handleUpdates("company")}
					></InputForm>
					<div style={{ marginTop: 20 }}>
						<IonButton
							expand="block"
							onClick={handleSubmit(handleSubmitSettings)}
						>
							{t("general.save")}
						</IonButton>
					</div>
				</IonCardContent>
			</IonCard>
		</WithNavigation>
	);
};

export default Settings;
